import create, {initializeAndRegisterHooks} from 'context/create' 
import hooks, * as resolves from './hooks'

const initialState = {
  types: false,
  questionTypes: undefined,
  typesMap: {},
  assessment: undefined,
  assessmentLoaded: false,
  assessments: undefined,
  refreshAssessments: 0
}

const id = 'Assessment'

const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, hooks, resolves)})

export {context as default}
